import apiAxios from "@/config/apiAxios";
import qs from 'qs';
import CryptoJS from "crypto-js";

export default {
    /**
     * 获取微信登录二维码
     * https://dcloud.genesysinfo.net/sso-center/test/wechatPub/ppop/{appCode}/{wxmpCode}/{scenceCode}
     */
    getWxLoginImg(conf) {
        return new Promise((resolve, reject) => {

           
            apiAxios.get(`${config.ssovfsUrl}/wechat/qrcode?scene_str=${config.appCode}${config.wxmpCode}${config.scenceCode}`, {}, _r => {
                if (_r && _r?.code == "200") {
                    resolve(_r);
                    // if( _r?.data?.qrcodeUrl ){
                    //     resolve( _r.data );
                    // }else{
                    //     console.warn( "get wechat-img faild1!" );
                    //     reject( _r );
                    // }
                } else {
                    console.warn("get wechat-img faild2!");
                    reject(_r);
                }
            })


            return;
            apiAxios.get(`${config.ssoUrl}/wechatPub/ppop/${conf.appCode}/${conf.wxmpCode}/${conf.scenceCode}`, {}, _r => {
                if (_r && _r?.code == "200") {
                    if (_r?.data?.qrcodeUrl) {
                        resolve(_r.data);
                    } else {
                        console.warn("get wechat-img faild1!");
                        reject(_r);
                    }
                } else {
                    console.warn("get wechat-img faild2!");
                    reject(_r);
                }
            })
        })
    },

    /**
     * 获取用户扫码状态
     * @param sceneId
     * @returns {Promise<unknown>}
     */
    checkUserScan(sceneId) {
        return new Promise((resolve, reject) => {
            apiAxios.get(`${config.ssovfsUrl}/wechat/check/scan`, {
                "scene_id": sceneId
            }, _r => {
                if (_r && _r?.code == "200") {
                    let data = JSON.parse(_r.data);
                    if (data.scan == 0) {
                        reject(_r)
                    } else if (data.scan == 1) {
                        // let _urlSearch = new URL(data?.redirectUrl).search.slice(1);
                        // let _params = qs.parse(_urlSearch, { allowPrototypes: true });
                        // let _code = _params.code;
                        // let _loginInfo = JSON.parse(CryptoJS.enc.Base64.parse(_code).toString(CryptoJS.enc.Utf8));
                        resolve(data);
                    }
                }

            })

            return;
            apiAxios.get(`${config.ssoUrl}/wechatPub/checkUserScan`, {
                "sceneId": sceneId
            }, _r => {
                if (_r?.data?.scan == 1) {
                    let _urlSearch = new URL(_r?.data?.redirectUrl).search.slice(1);
                    let _params = qs.parse(_urlSearch, { allowPrototypes: true });
                    let _code = _params.code;
                    let _loginInfo = JSON.parse(CryptoJS.enc.Base64.parse(_code).toString(CryptoJS.enc.Utf8));
                    resolve(_loginInfo);
                } else {
                    reject(_r);
                }
            })
        })
    },

    /**
     * 用户登录操作
     * @param param
     */
    doLogin(url) {
        return new Promise((resolve, reject) => {
            apiAxios.get(url, {}, _r => {
                if (_r.code == 200) {

                    let token = _r.token;
                    let satoken = _r.satoken;
                    let userInfo = _r.data;
                    sessionStorage.setItem(
                        "token",
                        token
                    );
                    sessionStorage.setItem("USER_TOKEN_TAG", "satoken");
                    sessionStorage.setItem(
                        "USER_TOKEN_VAL",
                        satoken
                    );
                    localStorage.setItem("USER_TOKEN_TAG", "satoken");
                    localStorage.setItem(
                        "USER_TOKEN_VAL",
                        satoken
                    );
                    sessionStorage.setItem("USER_ISLOGIN", true);
                    localStorage.setItem('USER_ISLOGIN', true);
                    sessionStorage.setItem("USER_INFO", JSON.stringify(userInfo));
                    localStorage.setItem(
                        "token",
                        token
                    );
                    let _isFix = true;
                    let companys = userInfo.companys || [];

                    if (userInfo.realName == "" || companys.length == 0) {
                        _isFix = false;
                    }

                    sessionStorage.setItem("USER_INFO_FIXED", _isFix);
                    var tags = userInfo.tags || [];
                    localStorage.setItem("USER_TAGS", JSON.stringify(tags))
                    //  var pageTags = "miniprogram_wxb5b5394c5fa71d90_yinsi";
                    var zysltags = "role_zysl_sale";
                    if (tags) {
                       
                        let zysltag = tags.find((_tag) => _tag == zysltags);
                        //是否是致远速联内部用户
                        if (zysltag) {
                            localStorage.setItem("iszysl", true);
                            //  app.globalData.iszysl = true;
                        }
                        // let pagetag = Object.keys(tags).find((_tag) => _tag == pageTags);
                        //   if (pagetag) {
                        localStorage.setItem("isyinsi", true);
                    }

                    resolve({ code: 200 })


                } else {
                    reject({ code: 500 });
                }

            })

            return;
            /*获取登录地址*/
            apiAxios.get(`${config.serverUrl}/cmss/v1/comp-service/getSsoLogin`, param, _r => {
                if (_r?.code == "200") {
                    let _loginUrl = _r.data?.url;
                    if (!_loginUrl || _loginUrl == undefined) {
                        this.$message.error("获取登录地址失败");
                    } else {
                        /*发送登录请求*/
                        if (_loginUrl == `${config.serverUrl}/sso-center/sso`)
                            _loginUrl = "https://${config.serverUrl}/sso-center/sso";
                        apiAxios.postRequestForm(`${_loginUrl}/doLogin`, param, (_tokenInfo, _r1) => {
                            if (_r1?.data?.code == "200") {
                                apiAxios.get(`${config.serverUrl}/cmss/v1/comp-service/getSsoLoginTicket`, { token: _tokenInfo.data?.tokenValue, url: `${window.localUrl}/redir.html?a=1` }, _r => {
                                    let _tickitUrl = _r?.data?.pop();
                                    if (_tickitUrl && _tickitUrl != undefined) {
                                        let _param = qs.parse(_tickitUrl);
                                        apiAxios.postRequestForm(`${config.serverUrl}/cmss/v1/comp-service/doLoginByTicket`, { ticket: _param.ticket }, _r => {
                                            sessionStorage.setItem('USER_TOKEN_TAG', _r.data?.tokenName);
                                            sessionStorage.setItem('USER_TOKEN_VAL', _r.data?.tokenValue);
                                            sessionStorage.setItem('USER_ISLOGIN', true);

                                            localStorage.setItem('USER_TOKEN_TAG', _r.data?.tokenName);
                                            localStorage.setItem('USER_TOKEN_VAL', _r.data?.tokenValue);
                                            localStorage.setItem('USER_ISLOGIN', true);

                                            resolve(_r.data);
                                        });
                                    } else {
                                        reject(_r);
                                        console.error("get login ticket faild");
                                    }
                                });
                            } else {
                                reject(_r1);
                            }
                        });
                    }
                } else {
                    this.$message.error("登录失败");
                }
            });
        })
    },

    doLogout(response) {
        sessionStorage.setItem('USER_ISLOGIN', false);
        localStorage.setItem('USER_ISLOGIN', false);
        response();
    },

    /**
     * 获取当前登录用户信息
     */
    getCurUsrInfo() {
        return new Promise((resolve, reject) => {
            let token=localStorage.getItem("token");
            if(token=="" || token==null){
                localStorage.setItem("USER_ISLOGIN",false)
                sessionStorage.setItem('USER_ISLOGIN', false);
                reject({code:500})
                return;
            }
            apiAxios.get(`${config.ssovfsUrl}user/info?token=${token}`,{},_r=>{
                if (_r?.code == "200") {
                    let _uInfo = _r?.data;
                    sessionStorage.setItem('USER_ISLOGIN', true);
                    sessionStorage.setItem('USER_ID', _uInfo?.id);
                    sessionStorage.setItem('USER_INFO', JSON.stringify(_uInfo));
                    let _isFix = true;
                    let companys = _uInfo.companys || [];

                    if (_uInfo.realName == "" || companys.length == 0) {
                        _isFix = false;
                    }

                    sessionStorage.setItem("USER_INFO_FIXED", _isFix);
                    resolve(_uInfo);
                } else {
                    localStorage.setItem("USER_ISLOGIN",false)
                    sessionStorage.setItem('USER_ISLOGIN', false);
                    reject({code:500});
                }
            })

            return;
            apiAxios.get(`${config.serverUrl}/cmss/v1/comp-service/user/center/info`, {}, _r => {
                if (_r?.code == "200") {
                    let _uInfo = _r?.data;
                    sessionStorage.setItem('USER_ISLOGIN', true);
                    sessionStorage.setItem('USER_ID', _uInfo?.id);
                    sessionStorage.setItem('USER_INFO', JSON.stringify(_uInfo));
                    resolve(_uInfo);
                } else {
                    reject(_r);
                }
            })
        })
    },
    /**
     * 根据用户ID列表查询用户信息
     */
    getUsersByIds(userIds, response) {
        apiAxios.post(`${config.ssoUrl}/user/list`, { uids: userIds }, response);
    },

    /**
     * 游客填写公司信息，更新
     * @param {*} userInfo
     * @param {*} response
     */
    customerSaveUserInfo(userInfo, response) {
        apiAxios.post(`${config.ssoUrl}/user`, userInfo, response);
    },

    /**
     * 修改用户信息
     * @param param
     * @param response
     * @returns {Promise<unknown>}
     */
    saveUserInfo(userInfo, response) {
        apiAxios.post(`${config.serverUrl}/cmss/v1/comp-service/user/center/saveUserInfo`, userInfo, response);
    },

    /**
     * 获取当前用户标签
     * @param response
     */
    getCurUsrTags(response) {
        apiAxios.get(`${config.serverUrl}/cmss/v1/comp-service/user/center/tag`, {}, response);
    },

}
